import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
  CabecalhoProtocolo,
  RateioDespesas,
  ColetorCustos,
  TipoDocumento,
  TipoDespesa,
  EmpresaMRV,
  DivisaoEmpresa,
  AprovadorSLD,
  Fornecedor,
  CondicaoPagamento,
  DocumentoPreEditadoRtn,
  SaldoAdiantamento,
  ImagemNotaFiscal,
  Responsavel,
  Funcionalidade,
  IAprovadorSLDResponse,
  User
} from '../../_models';
import {
  ColetorCustosService,
  EmpresaMRVService,
  AprovadorSLDService,
  FornecedorService,
  CondicaoPagamentoService,
  SaldoAdiantamentoService,
  UsuariosResponsaveisService,
  UserService
} from '../../_services';
import { TipoService } from 'src/app/_services/tipo.service';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { PopUpColetoresComponent } from '../popupColetores/popupColetores.component';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';
import { PopupAdiantamentosComponent } from '../popup-adiantamentos/popup-adiantamentos.component';
import { ConfirmacaoProtocoloComponent } from '../confirmacaoProtocolo/confirmacaoProtocolo.component';
import { PopupTermoAdiantamentoComponent } from '../popup-termo-adiantamento/popup-termo-adiantamento.component';
import { PopupColetorCustosComponent } from '../popup-coletor-custos/popup-coletor-custos.component';
import { DocumentoPreEditado } from '../../_models/DocumentoPreEditado';
import { Message } from '../../_models/Message';
import { DocumentoPreEditadoService } from '../../_services/DocumentoPreEditado.service';
import { NaoFiscalService } from '../../_services/naoFiscal.service';
import { UploadUCMService } from '../../_services/uploadUCM.service';
import { SelectionModel } from '@angular/cdk/collections';
import { AppComponent } from '../../app.component';
import { UploadFilesRtn } from '../../_models/UploadFilesRtn';
import { ActivatedRoute, Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { MaskService } from 'src/app/_services/mask.service';
import { CNPJAlfa } from 'src/app/_helpers/cnpj-alfa.util';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import moment from 'moment';
import { StatusProtocoloFiscalModalComponent } from '../status-protocolo-fiscal-modal/status-protocolo-fiscal-modal';
import { DataHoraService } from 'src/app/_services/data-hora.service';

@Component({
  selector: 'app-protocolo',
  templateUrl: './protocolo.component.html',
  styleUrls: ['./protocolo.component.css'],
})

export class ProtocoloComponent implements OnInit {
  @Input() LstUploadFiles: string[] = [];
  @Input() FormDataUpload = new FormData();

  @ViewChild('resetButton', { static: true }) resetButton: ElementRef;
  currentUser: User;

  // Validators
  cabecalhoForm: FormGroup;
  tipoDocumentoForm: FormGroup;
  rateioDespesasForm: FormGroup;

  // NgModel
  cabecalhoProtocolo = {} as CabecalhoProtocolo;
  rateioDespesas = {} as RateioDespesas;
  lstRateioDespesas = new Array<RateioDespesas>();
  lstImagem = new Array<ImagemNotaFiscal>();
  maxDate = null;

  // Screen rules
  formulario2Disbled: boolean;
  formulario3Disbled: boolean;
  tipoDocSelected = {} as TipoDocumento;
  step = 0;
  fv60 = true;
  Adiantamento = false;
  Fundofixo = false;
  fileUploadLenth = false;
  parcelado = false;
  diagramaDeRede = false;
  valorSerRateado: number;
  somaRateio = 0.00 as number;
  verifingColetor = false;
  creatingDocument = false;
  loadTipoDocs = false;
  loadCNPJs = false;
  confirmDocPreEditado: boolean;
  messageModel: Message;
  lstAdiantamentos: SaldoAdiantamento[];
  modoEdicao: boolean;
  fundoFixo: boolean;
  codigoBarrasValido = true as boolean;
  documentoSAP: string;
  carregandoDivisao = false;
  carregandoAprovador = false;
  carregarDivisao: string;
  PesColetorCustos: boolean;
  MesCorrente: boolean;
  bloquearBotaoSalvar = false;

  // API's returns
  public tipoDocs: TipoDocumento[];
  public funcionalidades: Funcionalidade[];
  public tipoDespesas: TipoDespesa[];
  public divisoesEmpresa: DivisaoEmpresa[];
  public aprovadoresSLD: AprovadorSLD[];
  public condicoesPagamento: CondicaoPagamento[];
  public responsaveis: Responsavel[];
  public coletoresCusto: ColetorCustos[];
  public saldosAdiantamentos: SaldoAdiantamento[];

  // Models
  public empresaMRV = new EmpresaMRV();
  public fornecedor = new Fornecedor();
  public tiposDespesaSelected = new TipoDespesa();
  public responsavelSelected = new Responsavel();
  public coletoresCustoError = new Array<ColetorCustos>();
  public documentoPreEditadoRtn = new DocumentoPreEditadoRtn();
  public protocoloEdicao = new DocumentoPreEditado();
  public uploadFilesRtn = new UploadFilesRtn();

  // Utilities
  mask: MaskService;
  filteredOptions: Observable<IAprovadorSLDResponse>;
  isLoading = false;

  // Controls Autocomplete
  frmDivisao = new FormControl();
  optionsDivisao: string[];
  filteredOptionsDivisao: Observable<string[]>;
  frmAprovador = new FormControl();
  optionsAprovador: string[];
  filteredOptionsAprovador: Observable<string[]>;
  idProtocolo: number;

  displayedColumns: string[] = ['tipoDespesa', 'tipoColetor', 'coletorCusto', 'numeroOperacao', 'descricao', 'valor', 'select'];
  dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
  selection = new SelectionModel<RateioDespesas>(true, []);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private loadComponent: AppComponent,
    private formBuilder: FormBuilder,
    private apiTipoDocService: TipoService,
    private apiTipoDespesa: TipoService,
    private apiValidateEmpMRV: EmpresaMRVService,
    private apiAprovadoresSLD: AprovadorSLDService,
    private apiValidateFornecedor: FornecedorService,
    private apiCondicaoPagamento: CondicaoPagamentoService,
    private apiColetorCustos: ColetorCustosService,
    private apiDocumentoPreEditado: DocumentoPreEditadoService,
    private apiNaoFiscal: NaoFiscalService,
    private apiUploadUCM: UploadUCMService,
    private apiSaldoAdiantamento: SaldoAdiantamentoService,
    private apiResponsaveis: UsuariosResponsaveisService,
    private apiUsuario: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private dateAdapter: DateAdapter<Date>,
    private apiDataHora: DataHoraService,
    private dialog?: MatDialog,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.dateAdapter.setLocale('pt-br');
    this.mask = new MaskService();
  }

  ngOnInit() {
    this.PesColetorCustos = false;
    this.InitializeForm();
    this.CarregarValidacoesTela();
    this.CarregarIntegracoes();

    $(document).on('click', '#DocNaoFiscao', function (e) {
      $('#TipoDoc').addClass('visible-none');
      $('#divDuvida').addClass('visible-none');
      $('#SelectDoc').removeClass('visible-none');
      $('#btnTipoDoc').removeAttr('disabled');
      return false;
    });
  }

  InitializeForm() {
    this.fundoFixo = false;
    // verifica se está no modo de edição
    this.idProtocolo = this.route.snapshot.params['idProtocolo'];
    if (this.idProtocolo !== undefined) {
      this.modoEdicao = true;
    } else {
      this.modoEdicao = false;
    }

    this.formulario2Disbled = true; // set true for production ou qa environments
    this.formulario3Disbled = true; // set true for production ou qa environments
    this.dataSource.paginator = this.paginator;
  }

  get f() { return this.cabecalhoForm.controls; }
  get fTpDoc() { return this.tipoDocumentoForm.controls; }
  get fRateio() { return this.rateioDespesasForm.controls; }

  onSubmitTipoDoc() {
    if (this.tipoDocSelected.codTipoDocumento === undefined) {
      this.dialog.open(PopupMessagesNewStyleTestComponent, {
        data: new Message('Tipo de Documento', 'É necessário escolher um tipo de documento', '', 'error')
      });
      return;
    }

    if (this.tipoDocSelected.codTipoDocumento === '13') {
      if (this.LstUploadFiles.length > 0 && this.tipoDocumentoForm.invalid) {
        this.fileUploadLenth = true;
        return;
      }
    } else if (this.tipoDocumentoForm.invalid || this.LstUploadFiles.length === 0) {
      this.fileUploadLenth = true;
      return;
    }

    if (this.tipoDocSelected.codTipoDocumento === '12') {
      this.dialog.open(
        PopupMessagesNewStyleTestComponent,
        {
          data: new Message(
            'Lembrete',
            'O pagamento do reembolso será agendado somente quando os documentos originais forem recebidos pelo Financeiro.',
            '',
            'alert'
          )
        }
      );
      this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
      this.nextStep();
      this.formulario2Disbled = false;
      this.fileUploadLenth = false;
      this.Adiantamento = false;
      this.fv60 = false;
      this.Fundofixo = true;
    }

    if (this.tipoDocSelected.codTipoDocumento == '13') {
      this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
      this.nextStep();
      this.formulario2Disbled = false;
      this.fileUploadLenth = false;
      this.fv60 = false;
      this.Fundofixo = false;
      this.Adiantamento = true;
    } else {
      this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
      this.nextStep();
      this.formulario2Disbled = false;
      this.fileUploadLenth = false;
    }
  }

  onSubmitCabecalho() {
    // stop here if form is invalid
    if (this.aprovadoresSLD.filter(x => x.nome === this.cabecalhoProtocolo.aprovador).length === 0) {
      this.cabecalhoProtocolo.aprovador = '';
    }

    if (this.divisoesEmpresa.filter(x => x.cod_descricao === this.cabecalhoProtocolo.divisao).length === 0) {
      this.cabecalhoProtocolo.divisao = '';
    }

    if (this.cabecalhoForm.invalid ||
      this.aprovadoresSLD.filter(x => x.nome === this.cabecalhoProtocolo.aprovador).length === 0 ||
      this.divisoesEmpresa.filter(x => x.cod_descricao === this.cabecalhoProtocolo.divisao).length === 0) {
      return;
    } else {
      this.messageModel = new Message(
        'Adiantamentos',
        'Deseja verifica se existe adiantamentos para esse fornecedor?',
        '',
        'confirm'
      );

      let confirmacaoAdiantamentos = false;
      const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });

      dialogRef.afterClosed().subscribe(result => {
        confirmacaoAdiantamentos = result;
        if (confirmacaoAdiantamentos != null && confirmacaoAdiantamentos) {
          this.loadComponent.startLoading(true);
          this.apiSaldoAdiantamento.getSaldosAdiantamentos(this.fornecedor.codigoFornecedor).subscribe(
            rtn => this.saldosAdiantamentos = rtn.data,
            err => console.error(err),
            () => {
              if (this.saldosAdiantamentos != null && this.saldosAdiantamentos.length > 0) {
                this.saldosAdiantamentos.forEach(s => s.checked = false);
                this.VerificaRetornoAdiantamentos(this.saldosAdiantamentos);
                this.nextStep();
                this.formulario3Disbled = false;
              }
              this.loadComponent.startLoading(false);
            });
        } else {
          this.nextStep();
          this.formulario3Disbled = false;
        }
      });
    }
  }

  clearFieldsRelated() {
    this.empresaMRV = new EmpresaMRV();
    this.divisoesEmpresa = new Array<DivisaoEmpresa>();
  }

  finishLoad() {
    this.loadComponent.startLoading(false);
  }

  CarregarIntegracoes() {
    if (this.modoEdicao) {
      this.loadComponent.startLoading(true);
    }

    this.getTipoDocumento();
    this.getAprovadoresSLD();
    this.getCondicoesPagamento();
    this.getResponsaveis();
  }

  desabilitarBotaoSalvar(): boolean {
    if (!this.ValidacoesSalvar() || this.bloquearBotaoSalvar) {
      return true;
    } else {
      return false;
    }
  }

  ValidarDadosRateio() {
    if (this.VerificaCamposObrigRateio()) {
      this.verifingColetor = true;
      this.apiColetorCustos.ObterColetoresCusto(
        this.rateioDespesas.identificacaoColetor.replace(' ', ''),
        this.rateioDespesas.codTipoColetor.toString(),
        this.empresaMRV.codigoEmp,
        this.cabecalhoProtocolo.divisao,
        null,
        null,
        this.rateioDespesas.operacaoSubNumero
      ).subscribe(
        data => this.coletoresCusto = data.data,
        err => console.error(err),
        () => {
          if (this.coletoresCusto != null) {
            this.VerificaColetoresInvalidos(this.coletoresCusto);
            this.verifingColetor = false;
          }
        }
      );
    }
  }

  CarregarValidacoesTela() {
    // VALIDAÇÕES FORMULÁRIO 1. TIPO DOCUMENTO
    this.tipoDocumentoForm = this.formBuilder.group({
      frmTipoDoc: ['', Validators.required],
    });

    // VALIDAÇÕES FORMULARIO 2. FICHA DO PROTOCOLO
    this.cabecalhoForm = this.formBuilder.group({
      frmCnpjEmpresa: ['', Validators.compose([Validators.required, Validators.minLength(14)])],
      frmNomeEmpresa: ['', Validators.required],
      frmCnpjFornecedor: ['', Validators.compose([Validators.required])],
      frmNomeFornecedor: ['', Validators.required],
      frmAprovador: ['', Validators.required],
      frmValor: ['', Validators.required],
      frmDivisao: ['', Validators.required],
      frmDtEmissao: ['', Validators.required],
      frmCondicaoPag: ['', Validators.required],
      frmPrimeiroVencimento: ['', Validators.required],
      frmResponsavel: ['', Validators.required],
      frmParcelado: [''],
      frmDescNota: ['', Validators.required],
      frmCodBarras: ['', Validators.compose([Validators.minLength(47), Validators.maxLength(48)])]
    });

    this.rateioDespesasForm = this.formBuilder.group({
      frmNumOperacao: ['', Validators.compose([Validators.required, Validators.maxLength(4)])],
      frmColetorCustos: ['', Validators.compose([Validators.required, this.validacaoTipoRateioTamanho])],
      frmValorDespesa: ['', Validators.required],
      frmTipoDespesa: ['', Validators.required],
      frmTipoColetor: ['', Validators.required],
      frmDescricaoDespesa: ['', Validators.required],
    });

    this.VerificaDiagramaDeRede();
    this.cabecalhoForm.controls['frmCondicaoPag'].disable();
    this.cabecalhoForm.controls['frmNomeEmpresa'].disable();
    this.cabecalhoForm.controls['frmNomeFornecedor'].disable();
  }

  CarregarDadosPreEditado() {
    let docPreEditado = new DocumentoPreEditado();

    if (this.modoEdicao) {
      docPreEditado.idProtocolo = this.route.snapshot.params['idProtocolo'];
    } else {
      docPreEditado.idProtocolo = 0;
    }

    docPreEditado.valor = this.cabecalhoProtocolo.valor;
    docPreEditado.dataEmissaoNf = new Date(this.cabecalhoProtocolo.emissao);
    docPreEditado.dataVencimentoNf = new Date(this.cabecalhoProtocolo.primeiroVencimento);
    docPreEditado.idTipoDocumento = Number(this.tipoDocSelected.codTipoDocumento);
    docPreEditado.descTipoDocumento = this.tipoDocSelected.tipoDocumento;
    docPreEditado.tipoDocumentoSap = this.tipoDocSelected.tipoDocumentoSap;
    docPreEditado.idStatusProtocolo = 51;
    docPreEditado.idStatusNovo = 1;
    docPreEditado.loginUsuarioCriacao = this.currentUser.login;
    docPreEditado.loginResponsavel = this.responsavelSelected.login;
    docPreEditado.loginUsuarioResponsavel = this.responsavelSelected.login;
    docPreEditado.emailUsuarioResponsavel = this.responsavelSelected.email;

    if (this.modoEdicao) {
      docPreEditado.dataHoraCriacao = this.protocoloEdicao.dataHoraCriacao;
    } else {
      docPreEditado.dataHoraCriacao = new Date();
    }

    docPreEditado.dataHoraAlteracao = new Date();
    docPreEditado.loginUsuarioUltAlteracao = this.currentUser.login;
    docPreEditado.nomeFornecedor = this.cabecalhoProtocolo.nomeFornecedor;
    docPreEditado.cnpjfornecedor = (this.fornecedor.cnpjFornecedor) ? this.fornecedor.cnpjFornecedor : this.fornecedor.cpfFornecedor;
    if (docPreEditado.cnpjfornecedor == null && docPreEditado.nomeFornecedor != null) {
      docPreEditado.cnpjfornecedor = this.fornecedor.codigoFornecedor
    }
    docPreEditado.cpffornecedor = this.fornecedor.cpfFornecedor;
    docPreEditado.cnpjDestinatario = CNPJAlfa.removeMascaraCNPJ(this.cabecalhoProtocolo.cnpjEmpresa);
    docPreEditado.nomeEmpresa = this.cabecalhoProtocolo.nomeEmpresa;
    docPreEditado.loginAprovador = this.aprovadoresSLD.filter(x => x.nome === this.cabecalhoProtocolo.aprovador)[0].login;
    docPreEditado.observacao = this.cabecalhoProtocolo.descricaoNota;
    docPreEditado.quantidadeRateio = this.lstRateioDespesas.length;
    docPreEditado.condicaoPagamento = this.cabecalhoProtocolo.codigoParametro;
    docPreEditado.parcelado = this.parcelado;
    docPreEditado.codDespesa = this.tiposDespesaSelected.codDespesa;
    docPreEditado.codBarras = this.cabecalhoProtocolo.codigoBarras;
    docPreEditado.divisao = this.divisoesEmpresa.filter(x => x.cod_descricao === this.cabecalhoProtocolo.divisao)[0].codigoDiv;
    docPreEditado.codEmpresa = this.empresaMRV.codigoEmp;
    docPreEditado.idSapFornecedor = this.fornecedor.codigoFornecedor;

    if (this.documentoSAP != null && this.documentoSAP !== '') { docPreEditado.documento = this.documentoSAP; }

    docPreEditado.rateios = this.lstRateioDespesas;
    docPreEditado.adiantamentos = this.lstAdiantamentos;

    if (this.cabecalhoProtocolo.imagens != null && this.cabecalhoProtocolo.imagens.length > 0) {
      docPreEditado.imagensNotaFiscal = this.cabecalhoProtocolo.imagens;
    }

    return docPreEditado;
  }

  ListarAdiantamentos() {
    this.loadComponent.startLoading(true);
    this.apiSaldoAdiantamento.getSaldosAdiantamentos(this.fornecedor.codigoFornecedor).subscribe(
      rtn => this.saldosAdiantamentos = rtn.data,
      err => console.error(err),
      () => {
        if (this.saldosAdiantamentos != null && this.saldosAdiantamentos.length > 0) {
          this.lstAdiantamentos.forEach(ad => {
            this.saldosAdiantamentos.forEach(s => {
              if (ad.numAdiantamento === s.numAdiantamento) {
                s.checked = true;
              }
            });
          });
          this.VerificaRetornoAdiantamentos(this.saldosAdiantamentos);
        }
        this.loadComponent.startLoading(false);
      }
    );
  }

  CarregarDadosTela(protocolo: DocumentoPreEditado) {
    this.formulario2Disbled = false;
    this.formulario3Disbled = false;

    const idTipoDoc = this.padLeft(protocolo.idTipoDocumento.toString(), '0', 2);

    this.tipoDocs.forEach(tp => {
      if (tp.codTipoDocumento === idTipoDoc) {
        this.tipoDocSelected = tp;
        this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
      }
    });

    this.cabecalhoProtocolo.cnpjEmpresa = protocolo.cnpjDestinatario;
    this.carregarEmpresaTomador();
    this.cabecalhoProtocolo.valor = protocolo.valor;
    this.cabecalhoProtocolo.emissao = protocolo.dataEmissaoNf;
    this.cabecalhoProtocolo.primeiroVencimento = protocolo.dataVencimentoNf;
    this.cabecalhoProtocolo.cnpjFornecedor = protocolo.cnpjfornecedor ?? protocolo.cpffornecedor;
    this.cabecalhoProtocolo.cpfFornecedor = protocolo.cpffornecedor;
    this.carregarFornecedor();
    this.cabecalhoProtocolo.DataHoraCriacao = protocolo.dataHoraCriacao;
    this.cabecalhoProtocolo.DataHoraAlteracao = protocolo.dataHoraAlteracao;
    this.cabecalhoProtocolo.descricaoNota = protocolo.observacao;
    this.lstRateioDespesas.length = protocolo.quantidadeRateio;
    this.parcelado = protocolo.parcelado;

    if (this.parcelado) {
      this.cabecalhoForm.controls['frmCondicaoPag'].enable();
    } else {
      this.cabecalhoForm.controls['frmCondicaoPag'].disable();
    }

    this.cabecalhoProtocolo.codigoParametro = protocolo.condicaoPagamento;
    this.tiposDespesaSelected.codDespesa = protocolo.codDespesa;
    this.cabecalhoProtocolo.codigoBarras = protocolo.codBarras;
    this.carregarDivisao = protocolo.divisao;
    this.empresaMRV.codigoEmp = protocolo.codEmpresa;
    this.fornecedor.codigoFornecedor = protocolo.idSapFornecedor;
    this.documentoSAP = JSON.parse(localStorage.getItem('documento'));
    this.lstAdiantamentos = protocolo.adiantamentos;
    this.lstRateioDespesas = protocolo.rateios;

    if (this.lstRateioDespesas.length > 0) {
      this.tipoDocumentoForm.controls['frmTipoDoc'].disable();
    }

    this.responsavelSelected = this.responsaveis.filter(r => r.login === protocolo.loginResponsavel)[0];
    this.cabecalhoForm.controls['frmResponsavel'].setValue(this.responsavelSelected);
    this.somaRateio = this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
    this.cabecalhoProtocolo.imagens = new Array<ImagemNotaFiscal>();

    protocolo.imagensNotaFiscal.forEach(i => {
      this.LstUploadFiles.push(i.nomeDocumento);
      const img = {} as ImagemNotaFiscal;
      img.nomeDocumento = i.nomeDocumento;
      img.dadosImagem = i.dadosImagem;
      img.dataHoraCriacao = i.dataHoraCriacao;
      img.chaveAcessoNfeletronica = i.chaveAcessoNfeletronica;
      img.dataExpurgoArquivo = i.dataExpurgoArquivo;
      img.idArquivo = i.idArquivo;
      img.idFormatoImagem = i.idFormatoImagem;
      img.idImagemNota = i.idImagemNota;
      img.idProtocolo = i.idProtocolo;
      img.idTipoImagemNf = i.idTipoImagemNf;
      img.loginUsuarioCriacao = i.loginUsuarioCriacao;
      img.numeroPaginas = i.numeroPaginas;
      img.possuiBoleto = i.possuiBoleto;
      img.urlDocumentos = i.urlDocumentos;
      this.cabecalhoProtocolo.imagens.push(img);
    });

    this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);

    if ((this.currentUser.login !== protocolo.loginResponsavel && !this.currentUser.movimentarProtocoloTerceiros) ||
      (protocolo.idStatusNovo !== 1 && protocolo.idStatusNovo !== 4)) {
      this.BloquearCamposTela();
    }

    // Bloqueados para a edição
    this.cabecalhoForm.controls['frmCnpjEmpresa'].disable();
    this.cabecalhoForm.controls['frmCnpjFornecedor'].disable();

    this.apiAprovadoresSLD.ObterAprovadores()
      .subscribe(data => {
        this.aprovadoresSLD = data.data;
        this.cabecalhoProtocolo.aprovador = this.aprovadoresSLD.filter(x => x.login === protocolo.loginAprovador)[0].nome;
        this.loadComponent.startLoading(false);
      });
  }

  validacaoTipoRateioTamanho = (control) => {

    const frmTipoColetor = control.parent?.get('frmTipoColetor');
    const frmColetorCustos = control.parent?.get('frmColetorCustos');

    if (frmTipoColetor && frmColetorCustos) {

      const tipoColetorCusto = frmTipoColetor.value;
      const coletorCusto = frmColetorCustos.value;

      if (tipoColetorCusto === 'N' && coletorCusto.length > 12) {
        return { 'erroTipoRateioValidacao': 'Esse tipo de coletor não pode exceder 12 caracteres.' };
      }

      if (tipoColetorCusto === 'K' && coletorCusto.length > 10) {
        return { 'erroTipoRateioValidacao': 'Esse tipo de coletor não pode exceder 10 caracteres.' };
      }

    }

    return null;
  }


  CarregarDadosTelaAdiantamento(protocolo: DocumentoPreEditado) {
    // Bloqueados para a edição
    this.formulario2Disbled = false;
    this.fileUploadLenth = false;
    this.fv60 = false;
    this.Fundofixo = false;
    this.Adiantamento = true;

    this.cabecalhoForm.controls['frmCnpjEmpresa'].disable();
    this.cabecalhoForm.controls['frmCnpjFornecedor'].disable();

    const idTipoDoc = this.padLeft(protocolo.idTipoDocumento.toString(), '0', 2);

    this.tipoDocs.forEach(tp => {
      if (tp.codTipoDocumento === idTipoDoc) {
        this.tipoDocSelected = tp;
        this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
      }
    });

    this.cabecalhoProtocolo.imagens = new Array<ImagemNotaFiscal>();

    protocolo.imagensNotaFiscal.forEach(i => {
      this.LstUploadFiles.push(i.nomeDocumento);
      const img = {} as ImagemNotaFiscal;
      img.nomeDocumento = i.nomeDocumento;
      img.dadosImagem = i.dadosImagem;
      img.dataHoraCriacao = i.dataHoraCriacao;
      img.chaveAcessoNfeletronica = i.chaveAcessoNfeletronica;
      img.dataExpurgoArquivo = i.dataExpurgoArquivo;
      img.idArquivo = i.idArquivo;
      img.idFormatoImagem = i.idFormatoImagem;
      img.idImagemNota = i.idImagemNota;
      img.idProtocolo = i.idProtocolo;
      img.idTipoImagemNf = i.idTipoImagemNf;
      img.loginUsuarioCriacao = i.loginUsuarioCriacao;
      img.numeroPaginas = i.numeroPaginas;
      img.possuiBoleto = i.possuiBoleto;
      img.urlDocumentos = i.urlDocumentos;
      this.cabecalhoProtocolo.imagens.push(img);
    });
  }

  CarregarDadosTelaFundoFixo(protocolo: DocumentoPreEditado) {
    // Bloqueados para a edição
    this.formulario2Disbled = false;
    this.fileUploadLenth = false;
    this.Adiantamento = false;
    this.fv60 = false;
    this.Fundofixo = true;

    this.cabecalhoForm.controls['frmCnpjEmpresa'].disable();
    this.cabecalhoForm.controls['frmCnpjFornecedor'].disable();

    const idTipoDoc = this.padLeft(protocolo.idTipoDocumento.toString(), '0', 2);

    this.tipoDocs.forEach(tp => {
      if (tp.codTipoDocumento === idTipoDoc) {
        this.tipoDocSelected = tp;
        this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
      }
    });

    this.lstRateioDespesas = protocolo.rateios;
    if (this.lstRateioDespesas.length > 0) {
      this.tipoDocumentoForm.controls['frmTipoDoc'].disable();
    }

    this.cabecalhoProtocolo.imagens = new Array<ImagemNotaFiscal>();

    protocolo.imagensNotaFiscal.forEach(i => {
      this.LstUploadFiles.push(i.nomeDocumento);
      const img = {} as ImagemNotaFiscal;
      img.nomeDocumento = i.nomeDocumento;
      img.dadosImagem = i.dadosImagem;
      img.dataHoraCriacao = i.dataHoraCriacao;
      img.chaveAcessoNfeletronica = i.chaveAcessoNfeletronica;
      img.dataExpurgoArquivo = i.dataExpurgoArquivo;
      img.idArquivo = i.idArquivo;
      img.idFormatoImagem = i.idFormatoImagem;
      img.idImagemNota = i.idImagemNota;
      img.idProtocolo = i.idProtocolo;
      img.idTipoImagemNf = i.idTipoImagemNf;
      img.loginUsuarioCriacao = i.loginUsuarioCriacao;
      img.numeroPaginas = i.numeroPaginas;
      img.possuiBoleto = i.possuiBoleto;
      img.urlDocumentos = i.urlDocumentos;
      this.cabecalhoProtocolo.imagens.push(img);
    });
  }

  BloquearCamposTela() {
    this.tipoDocumentoForm.controls['frmTipoDoc'].disable();
    this.cabecalhoForm.controls['frmCnpjEmpresa'].disable();
    this.cabecalhoForm.controls['frmCnpjFornecedor'].disable();
    this.cabecalhoForm.controls['frmAprovador'].disable();
    this.cabecalhoForm.controls['frmValor'].disable();
    this.cabecalhoForm.controls['frmDivisao'].disable();
    this.cabecalhoForm.controls['frmDtEmissao'].disable();
    this.cabecalhoForm.controls['frmCondicaoPag'].disable();
    this.cabecalhoForm.controls['frmPrimeiroVencimento'].disable();
    this.cabecalhoForm.controls['frmResponsavel'].disable();
    this.cabecalhoForm.controls['frmDescNota'].disable();
    this.cabecalhoForm.controls['frmCodBarras'].disable();
    this.cabecalhoForm.controls['frmParcelado'].disable();
    this.rateioDespesasForm.controls['frmNumOperacao'].disable();
    this.rateioDespesasForm.controls['frmColetorCustos'].disable();
    this.rateioDespesasForm.controls['frmValorDespesa'].disable();
    this.rateioDespesasForm.controls['frmTipoDespesa'].disable();
    this.rateioDespesasForm.controls['frmTipoColetor'].disable();
    this.rateioDespesasForm.controls['frmDescricaoDespesa'].disable();
  }

  FiltrarTipoDocumentoPorFuncionalidades(tipoDocumentos: TipoDocumento[]) {
    this.apiUsuario.getFuncionalidadesUsuario().subscribe(data => {
      this.funcionalidades = data.data || [];
      this.funcionalidades = this.funcionalidades || data.data.result;
      this.funcionalidades = this.funcionalidades || [];
      const tipoDocTemp = new Array<TipoDocumento>();
      this.funcionalidades.forEach(f => {
        let td = this.tipoDocs.filter(td => td.codigoFuncionalidade === f.codigoFuncionalidade)[0];
        if (td !== undefined) { tipoDocTemp.push(td); }
      });
      this.tipoDocs = tipoDocTemp.sort((a, b) => (a.tipoDocumento > b.tipoDocumento) ? 1 : ((b.tipoDocumento > a.tipoDocumento) ? -1 : 0));
    }).add(() => this.loadTipoDocs = false);

    return tipoDocumentos.sort((a, b) => (a.tipoDocumento > b.tipoDocumento) ? 1 : ((b.tipoDocumento > a.tipoDocumento) ? -1 : 0));
  }

  VerificaTipoDocumentoUsuario() {
    if (!this.tipoDocs.find(tp => tp === this.tipoDocSelected)) {
      this.BloquearCamposTela();
      this.messageModel = new Message(
        'Atenção',
        `Usuário não possui acesso ao tipo de documento ${this.tipoDocSelected.tipoDocumento}.` +
        ` Protocolo disponível somente para visualização.`,
        '',
        'error'
      );
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return false;
    }

    return true;
  }

  // ================= COMUNICAÇÕES COM API/SERVICES =====================
  carregarDadosProtocolo(protocoloID: string) {
    this.navigateTipoDoc();

    this.apiDocumentoPreEditado.obterProtocolo(protocoloID).subscribe(
      data => this.protocoloEdicao = data.data,
      err => console.error(err),
      () => {
        if (this.protocoloEdicao != null && this.protocoloEdicao.idTipoDocumento === 12) {
          this.fundoFixo = true;
          this.CarregarDadosTelaFundoFixo(this.protocoloEdicao);
        } else if (this.protocoloEdicao != null && this.protocoloEdicao.idTipoDocumento === 13) {
          this.Adiantamento = true;
          this.CarregarDadosTelaAdiantamento(this.protocoloEdicao);
        } else if (this.protocoloEdicao != null) {
          this.Adiantamento = false;
          this.fundoFixo = false;
          this.CarregarDadosTela(this.protocoloEdicao);
        }
      }
    ).add(() => this.loadTipoDocs = false);
  }

  getTipoDocumento() {
    this.loadComponent.startLoading(true);
    this.apiTipoDocService.obterTiposDocumentoNaoFiscal().subscribe(data => this.tipoDocs = data.data,
      err => {
        console.error(err);
        this.messageModel = new Message(
          'Erro ao realizar integração com SAP',
          '',
          `Tente recarregar a tela novamente`,
          'error'
        );
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        this.loadComponent.startLoading(false);
      },
      () => {
        if (this.tipoDocs != null && this.tipoDocs.some(tp => tp.status === 'E')) {
          let strErro = this.tipoDocs.find(tp => tp.status === 'E').mensagem;
          this.messageModel = new Message(
            'Erro ao realizar integração com SAP',
            '',
            `Tente recarregar a tela novamente. Detalhes do erro: ${strErro} `,
            'error'
          );

          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        } else {
          this.tipoDocs = this.tipoDocs.filter(obj => obj.tipoDocumento !== 'DEPÓSITO');
          this.tipoDocs = this.FiltrarTipoDocumentoPorFuncionalidades(this.tipoDocs);
          // Verifica se está em modo de edição
          if (this.modoEdicao) {
            this.carregarDadosProtocolo(this.route.snapshot.params['idProtocolo']);
          }
        }
        this.loadComponent.startLoading(false);
        this.tipoDocs = this.tipoDocs.sort(
          (a, b) => (a.tipoDocumento > b.tipoDocumento) ? 1 : ((b.tipoDocumento > a.tipoDocumento) ? -1 : 0)
        );
      });
  }

  getTiposDespesas(tipoDoc: string) {
    this.apiTipoDespesa.getTipoDespesas(tipoDoc).subscribe(
      data => {
        this.tipoDespesas = data.data;
        // preenche lista de rateios quando em modo edição
        if (!this.fundoFixo && !this.Adiantamento) {
          this.lstRateioDespesas.forEach(r => {
            r.nomeTipoDespesa = this.tipoDespesas.filter(tpDespesa => Number(tpDespesa.codDespesa) === Number(r.codDespesa))[0].tipoDespesa;
          });
        }
      }
    );
  }

  getAprovadoresSLD() {
    this.carregandoAprovador = true;

    this.apiAprovadoresSLD.ObterAprovadores().subscribe(
      data => {
        this.aprovadoresSLD = data.data;
        const userString = localStorage.getItem('currentUser');
        const user = JSON.parse(userString);
        const loginDoUsuario = user.login.toUpperCase();
        const filteredAprovadores = this.aprovadoresSLD.filter(aprovador => aprovador.login.toUpperCase() !== loginDoUsuario);
        this.optionsAprovador = filteredAprovadores.map(({ nome }) => nome);
        this.filteredOptionsAprovador = this.frmAprovador.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterAprovador(value))
          );
        this.carregandoAprovador = false;
      }
    );
  }

  private _filterAprovador(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsAprovador.filter(option => option.toLowerCase().includes(filterValue));
  }

  getCondicoesPagamento() {
    this.apiCondicaoPagamento.ObterCondicoesPagamento().subscribe(data => this.condicoesPagamento = data.data);
  }

  getResponsaveis() {
    this.apiResponsaveis.getResponsaveis().subscribe(data => {
      this.responsaveis = data.data;
      this.responsavelSelected = this.responsaveis.filter(r => r.login === this.currentUser.login)[0];
      this.cabecalhoForm.controls['frmResponsavel'].setValue(this.responsavelSelected);
      this.cabecalhoForm.controls['frmResponsavel'].disable();
    });
  }

  formatarCNPJEmpresaInput(event: any) {
    let valor = event.target.value;
    valor = valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

    if (valor.length > 2) { valor = valor.substring(0, 2) + '.' + valor.substring(2); }
    if (valor.length > 6) { valor = valor.substring(0, 6) + '.' + valor.substring(6); }
    if (valor.length > 10) { valor = valor.substring(0, 10) + '/' + valor.substring(10); }
    if (valor.length > 15) { valor = valor.substring(0, 15) + '-' + valor.substring(15, 17); }

    // Atualiza DOM e form control diretamente para evitar que o DefaultValueAccessor
    // do Angular sobrescreva a formatação via [(ngModel)]
    event.target.value = valor;
    this.cabecalhoProtocolo.cnpjEmpresa = valor;
    this.cabecalhoForm.controls['frmCnpjEmpresa'].setValue(valor, { emitEvent: false });
  }

  carregarEmpresaTomador() {
    if (this.cabecalhoProtocolo.cnpjEmpresa !== "") {
      const cnpjSemMascara = CNPJAlfa.removeMascaraCNPJ(this.cabecalhoProtocolo.cnpjEmpresa);

      // Validar CNPJ (numérico ou Alfa) — campo empresa aceita apenas CNPJ (14 chars)
      if (cnpjSemMascara.length !== 14 || !CNPJAlfa.isValid(cnpjSemMascara)) {
        this.clearFieldsRelated();
        this.messageModel = new Message("CNPJ Inválido", "", "O CNPJ da empresa é inválido. Verifique os dígitos verificadores.", "warning");
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }

      this.cabecalhoProtocolo.cnpjEmpresa = CNPJAlfa.formatarCNPJ(cnpjSemMascara);

      this.loadCNPJs = true;
      this.apiValidateEmpMRV.ObterEmpresaMrv(cnpjSemMascara).subscribe(
        data => { this.empresaMRV = data.data; },
        err => console.error(err),
        () => {
          if (this.empresaMRV === null) {
            this.clearFieldsRelated();
          } else {
            this.getDivisaoByEmpresa();
            this.cabecalhoForm.controls['frmNomeEmpresa'].setValue(this.empresaMRV.descricaoEmp);
          }
          this.loadCNPJs = false;
        });
    } else {
      this.clearFieldsRelated();
    }
  }

  carregarFornecedor() {
    if (this.cabecalhoProtocolo.cnpjFornecedor !== "") {
      // Remover máscara e converter para maiúsculas (suporta CNPJ Alfa)
      const cnpjSemMascara = CNPJAlfa.removeMascaraCNPJ(this.cabecalhoProtocolo.cnpjFornecedor);

      // Validar CNPJ somente se tiver 14 caracteres (campo aceita CPF e código também)
      if (cnpjSemMascara.length === 14 && !CNPJAlfa.isValid(cnpjSemMascara)) {
        this.fornecedor = new Fornecedor();
        this.messageModel = new Message("CNPJ Inválido", "", "O CNPJ do fornecedor é inválido. Verifique os dígitos verificadores.", "warning");
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }

      this.cabecalhoProtocolo.cnpjFornecedor = cnpjSemMascara;
      this.loadCNPJs = true;
      this.apiValidateFornecedor.ObterFornecedor(cnpjSemMascara).subscribe(
        data => {
          this.fornecedor = data.data;
          this.fornecedor.dataFixa = data.data.dataFixa == 'X';
          this.fornecedor.nomeFornecedor = this.fornecedor.codigoFornecedor + ' - ' + this.fornecedor.nomeFornecedor;
        },
        err => console.error(err),
        () => {
          this.verificaFornecedor(this.fornecedor);
          this.verificaDataFixa(this.fornecedor);
          this.loadCNPJs = false;
        }
      );
    } else {
      this.fornecedor = new Fornecedor();
    }
  }

  validarDataVencimento(event) {
    let dataSelecionada = event.target.value || null;
    dataSelecionada = moment(dataSelecionada, 'DD/MM/YYYY').toISOString();

    if (this.fornecedor.dataFixa) {
      dataSelecionada = this.verificaDataVencimento(dataSelecionada);
    }

    this.cabecalhoForm.controls['frmPrimeiroVencimento'].setValue(new Date(dataSelecionada));

    this.loadComponent.startLoading(true);

    this.apiDataHora.ValidarDataVencimento(this.cabecalhoProtocolo.primeiroVencimento, parseInt(this.tipoDocSelected.codTipoDocumento)).subscribe(
      result => {
        if (!result.success) {
          this.ExibeMensagemUpload('Data de Vencimento', result.errors, 'warning');
        }
        this.loadComponent.startLoading(false);
      }, err => {
        this.ExibeMensagemUpload('Data de Vencimento', 'Ocorreu um erro ao validar a data de vencimento: ' + err, 'error');

        this.loadComponent.startLoading(false);
      }
    );

  }

  verificaDataFixa(fornecedor: Fornecedor) {
    if (fornecedor.dataFixa) {
      this.ExibeMensagemUpload('Data Fixa',
        'Devido ao fornecedor ser aderente a nova forma de pagamento com data fixa, a data de vencimento será alterada para dia 10 ou 29.',
        'warning')
    }
  }

  verificaDataVencimento(dataSelecionada: any) {
    let dataVencimento: Date = new Date(dataSelecionada);
    let dia = dataVencimento.getDate();

    if (dia <= 10) {
      return dataVencimento.setDate(10);
    }
    else if (dia > 10 && dia <= 29) {
      return dataVencimento.setDate(29);
    }
    else {
      dataVencimento.setDate(10);
      dataVencimento.setMonth(dataVencimento.getMonth() + 1);
      return dataVencimento;
    }
  }

  getDivisaoByEmpresa() {
    this.carregandoDivisao = true;

    this.apiValidateEmpMRV.ObterDivisoesEmpresaMrv(this.empresaMRV.cnpjEmp, this.empresaMRV.codFil).subscribe(data => {
      this.divisoesEmpresa = data.data;
      this.optionsDivisao = this.divisoesEmpresa.map(({ cod_descricao }) => cod_descricao);
      this.filteredOptionsDivisao = this.frmDivisao.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterDivisao(value))
        );
      this.carregandoDivisao = false;
      this.carregarDivisao = this.carregarDivisao || '';
      if (this.carregarDivisao !== '') {
        this.cabecalhoProtocolo.divisao = this.divisoesEmpresa.filter(x => x.codigoDiv === this.carregarDivisao)[0].cod_descricao;
      }
    });
  }

  private _filterDivisao(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.optionsDivisao.filter(x => x.toLowerCase().includes(filterValue));
  }

  uploadFiles(documento: DocumentoPreEditado) {
    let temp;
    this.FormDataUpload.delete('DocumentoPreEditadoUpload');
    this.FormDataUpload.append('DocumentoPreEditadoUpload', JSON.stringify(documento));
    this.apiUploadUCM.upload(this.FormDataUpload).subscribe(
      rtn => temp = rtn,
      err => { console.error(err); this.loadComponent.startLoading(false); },
      () => {
        if (temp?.data?.success === false) {
          this.ExibeMensagemUpload('Erro ao enviar as imagens para o UCM. Tente novamente.', temp.data.message);
          this.loadComponent.startLoading(false);
        } else {
          this.loadComponent.startLoading(false);
          this.ExibeMensagemSucessoProtocolo(documento.idProtocolo, documento.documento);
        }

        this.loadComponent.startLoading(false);
      }
    );
  }

  AtualizarProtocolo(documento: DocumentoPreEditado) {
    let temp;
    this.FormDataUpload.delete('DocumentoPreEditadoUpload');
    this.FormDataUpload.append('DocumentoPreEditadoUpload', JSON.stringify(documento));
    this.apiUploadUCM.upload(this.FormDataUpload).subscribe(
      rtn => temp = rtn,
      err => { console.error(err); },
      () => {
        if (temp?.data?.success === false) {
          this.ExibeMensagemUpload('Erro ao enviar as imagens para o UCM. Tente novamente.', temp.data.message);
          this.loadComponent.startLoading(false);
        } else {
          this.AtualizarProtocoloIntegracoes();
        }
      }).add();
  }

  AtualizarProtocoloIntegracoes() {
    this.apiNaoFiscal.AtualizarProtocoloNaoFiscal(this.FormDataUpload).subscribe(
      rtn => this.documentoPreEditadoRtn = rtn?.data,
      err => {
        this.loadComponent.startLoading(false);
        this.messageModel = new Message('Erro ao editar', err, '', '');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        console.error(err);
      },
      () => {
        if (this.documentoPreEditadoRtn?.success) {
          this.ExibeMensagemSucessoProtocolo(this.documentoPreEditadoRtn.data.idProtocolo, this.documentoPreEditadoRtn.data.documento);
        } else {
          this.messageModel = new Message(
            'Ocorreu um problema ao criar o documento pré-editado no SAP',
            this.documentoPreEditadoRtn.message,
            '',
            'error'
          );

          this.loadComponent.startLoading(false);
          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        }
        this.loadComponent.startLoading(false);
      }
    );
  }

  ExibeMensagemSucessoProtocolo(idProtocolo: number, documento: string) {
    let title = 'Item processado com sucesso';
    let message = `N° Protocolo: ${idProtocolo} - N° Pedido Não Fiscal: ${documento}`;
    this.messageModel = new Message(title, "", `Detalhes: ${message} `, 'success');
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    dialogRef.afterClosed().subscribe(r => {
      this.router.navigate(['/home']);
    });
  }

  ExibeMensagemUpload(title: string, message: string, status: string = null) {
    this.messageModel = new Message(title, '', `Detalhes: ${message} `, status);

    this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }

  incluirRateio() {
    // Validators
    if (this.rateioDespesasForm.invalid) {
      return;
    }

    this.rateioDespesas.identificacaoColetor = this.rateioDespesas.identificacaoColetor.toUpperCase().replace(' ', '');
    // Validate ColetoresCusto
    this.ValidarDadosRateio();
  }

  ExibeMensagemValorRateios() {
    this.messageModel = new Message(
      'Problema ao inserir o rateio',
      'Valor Rateio',
      'O valor do total dos rateios será maior que o valor inserido na ficha do protocolo. Tente um valor menor.',
      'warning'
    );

    this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }

  IncluirRateioDataSource() {
    // Generate rateioDespesas object
    this.rateioDespesas.codDespesa = this.tiposDespesaSelected.codDespesa;
    this.rateioDespesas.nomeTipoDespesa = this.tiposDespesaSelected.tipoDespesa;
    this.rateioDespesas.contaRazao = this.tiposDespesaSelected.contaRazao;
    this.rateioDespesas.usuarioAlteracao = this.currentUser.login;
    this.rateioDespesas.usuarioCadastro = this.currentUser.login;
    this.rateioDespesas.valor = Number(this.rateioDespesas.valor.toFixed(5));
    this.PesColetorCustos = false;

    let somaRateiosJaListados = Number(this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0));

    let valorTotal = this.rateioDespesas.valor + somaRateiosJaListados;

    let somaRateios = parseFloat(valorTotal.toFixed(2));
    if (somaRateios > this.cabecalhoProtocolo.valor) {
      this.ExibeMensagemValorRateios();
      return;
    }

    // Add rateioDespesas object in table datasouce
    this.lstRateioDespesas.push(this.rateioDespesas);
    this.tipoDocumentoForm.controls['frmTipoDoc'].disable();
    this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
    this.dataSource.paginator = this.paginator;
    this.somaRateio = this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
    this.somaRateio = Number(this.somaRateio.toFixed(5));

    // CLEAR RATEIO FIELDS
    this.rateioDespesas = {} as RateioDespesas;
    this.tiposDespesaSelected = new TipoDespesa();

    this.clearValidatorsAndResetRateioDespesasForm();
  }

  clearValidatorsAndResetRateioDespesasForm() {
    // Limpar campos e validações
    this.rateioDespesasForm.reset();
    this.rateioDespesasForm.clearValidators();

    // Limpar mensagens de erro
    Object.keys(this.rateioDespesasForm.controls).forEach(key => {
      this.rateioDespesasForm.controls[key].setErrors(null);
    });

    // Marcar controles como intocados e não modificados
    this.rateioDespesasForm.markAsPristine();
    this.rateioDespesasForm.markAsUntouched();
  }

  CriarProtocolo(docPreEditado: DocumentoPreEditado) {
    this.FormDataUpload.delete('DocumentoPreEditado');
    this.FormDataUpload.append('DocumentoPreEditado', JSON.stringify(docPreEditado));

    if (!this.modoEdicao) {
      this.loadComponent.startLoading(true);
      this.apiNaoFiscal.CriarProtocoloNaoFiscal(this.FormDataUpload).subscribe(
        rtn => {
          this.documentoPreEditadoRtn = rtn.data;
          this.loadComponent.startLoading(false);
        },
        err => {
          console.error(err);
          this.loadComponent.startLoading(false);
        },
        () => {
          if (this.documentoPreEditadoRtn != null) {
            this.VerificaRetornoDocumento(this.documentoPreEditadoRtn);
          }
        }).add(() => this.loadComponent.startLoading(false));
    } else {
      this.AtualizarProtocolo(docPreEditado);
    }
  }

  VerificaDuplicidade(docPreEditado: DocumentoPreEditado) {
    let confirmaGravacaoDuplicidade = false;
    let rtn: DocumentoPreEditadoRtn;

    //this.loadComponent.startLoading(true);
    this.apiNaoFiscal.VerificaDuplicidadeNaoFiscal(docPreEditado).subscribe(
      data => {
        rtn = data.data;
        if (rtn?.success) {
          this.messageModel = new Message(
            'Atenção',
            'Já existe um protocolo com esse fornecedor, valor, data de emissão e data de vencimento. Deseja prosseguir?',
            '',
            'confirm'
          );
          const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          dialogRef.afterClosed().subscribe(result => {
            confirmaGravacaoDuplicidade = result;
            // Caso haja a confirmação dos dados pre-editados e a confirmação de gravar em duplicidade é criado o protocolo
            if (confirmaGravacaoDuplicidade) {
              this.CriarProtocolo(docPreEditado);
            } else {
              this.loadComponent.startLoading(false);
            }
          });
        } else { this.CriarProtocolo(docPreEditado); }
      });
  }

  ValidacoesSalvar() {
    // Validação de campos obrigatórios
    if (this.cabecalhoForm.invalid || this.tipoDocumentoForm.invalid || this.lstRateioDespesas.length === 0) {
      return false;
    }

    // Valores divergentes para o rateio
    if (Number(this.cabecalhoProtocolo.valor.toFixed(5)) !== Number(this.somaRateio.toFixed(5))) {
      this.messageModel = new Message('Atenção', 'Verifique o valor restante a ser rateado', '', 'warning');
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return false;
    }

    // Validações da validade do coletores de custo
    if (this.coletoresCustoError.length > 0) {
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.coletoresCustoError });
      return false;
    }

    return true;
  }

  CancelarProtocolo() {
    let confirmCancel = false as boolean;
    let rtn: DocumentoPreEditadoRtn;

    // Validação de status
    if (this.modoEdicao) {
      if (this.protocoloEdicao.idStatusNovo === 9) {
        this.messageModel = new Message('Atenção', 'Documento já cancelado, não é possível executar operação', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }


      if (this.protocoloEdicao.idStatusNovo === 6 || // Pendente de Processamento da Fatura
        this.protocoloEdicao.idStatusNovo === 7 || // Aguardando Pagamento
        this.protocoloEdicao.idStatusNovo === 8 || // Concluído/Pago
        this.protocoloEdicao.idStatusNovo === 10) // Aguardando Lançamento da Fatura
        {
          this.messageModel = new Message('Atenção', 'Não é possível realizar o cancelamento do protocolo para o status atual', '', 'warning');
          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          return;
        }
    }

    // Validação do perfil de movimentação de protocolos de terceiros
    if ((this.currentUser.login !== this.protocoloEdicao.loginResponsavel
      && !this.currentUser.movimentarProtocoloTerceiros)) {
      this.messageModel = new Message('Atenção', 'Não é possível realizar o cancelamento de protocolos de terceiros', '', 'warning');
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return;
    }

    this.messageModel = new Message(
      'Atenção',
      'Ao confirmar a exclusão do protocolo, o mesmo será eliminado permanentemente. O processo de cancelamento pode demorar alguns instantes, por gentileza aguardar o retorno do sistema caso deseje prosseguir com o cancelamento. Deseja Continuar?',
      '',
      'confirm'
    );
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    this.loadComponent.startLoading(true);
    dialogRef.afterClosed().subscribe(result => {
      confirmCancel = result;

      if (confirmCancel) {

        this.apiNaoFiscal.CancelarProtocoloNaoFiscal(this.CarregarDadosPreEditado()).subscribe(
          data => {
            rtn = data.data;

            if (rtn?.success) {
              this.messageModel = new Message('Atenção', 'Protocolo cancelado com sucesso', '', 'success');
              this.router.navigate(['/home']);
            } else {
              this.messageModel = new Message('Atenção', rtn.message, '', 'warning');
            }

            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
            this.loadComponent.startLoading(false);
          }
        );
      }
    });
  }

  Salvar() {
    if (!this.ValidacoesSalvar()) { return; }

    this.bloquearBotaoSalvar = true;

    let docPreEditado = this.CarregarDadosPreEditado();

    // Validação de perfil
    if (this.currentUser.login !== docPreEditado.loginResponsavel && !this.currentUser.movimentarProtocoloTerceiros) {
      this.messageModel = new Message(
        'Atenção',
        'Seu usuário não possui acesso para modificação de protocolos de terceiros',
        '',
        'warning'
      );

      this.dialog.open(PopupMessagesNewStyleTestComponent, {
        data: this.messageModel
      });
      return;
    }

    // Validação de status
    if (this.modoEdicao) {
      if (this.protocoloEdicao.idStatusNovo === 9) {
        this.messageModel = new Message('Atenção', 'Documento já cancelado, não é possível executar operação', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, {
          data: this.messageModel
        });
        return;
      }

      if (this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4 && this.protocoloEdicao.idStatusNovo !== 7) {
        this.messageModel = new Message('Atenção', 'Documento já aprovado, não é possível editar', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, {
          data: this.messageModel
        });
        return;
      }
    }

    if (docPreEditado.dataEmissaoNf >= new Date()) {
      this.messageModel = new Message('Atenção', 'A data de emissão não pode ser maior do que a data atual', '', 'warning');
      this.dialog.open(PopupMessagesNewStyleTestComponent, {
        data: this.messageModel
      });
      return;
    }

    // Confirmar gravação
    const dialogRef = this.dialog.open(ConfirmacaoProtocoloComponent, { data: docPreEditado });

    dialogRef.afterClosed().subscribe(result => {
      this.confirmDocPreEditado = result;

      // Verificar duplicidade na base e grava o protocolo
      if (this.confirmDocPreEditado != null && this.confirmDocPreEditado) {
        this.loadComponent.startLoading(true);
        this.VerificaDuplicidade(docPreEditado);
      }
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  deleteRow(row) {

    if (this.modoEdicao && !this.currentUser.movimentarProtocoloTerceiros &&
      this.protocoloEdicao.loginResponsavel !== this.currentUser.login ||
      (this.modoEdicao && this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4)) {
      return;
    }

    this.messageModel = new Message(
      'Rateios',
      'Confirma a exclusão do item?',
      '',
      'confirm'
    );

    let confirmDeleteRateio = false;
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });

    dialogRef.afterClosed().subscribe(result => {
      confirmDeleteRateio = result;
      if (confirmDeleteRateio != null && confirmDeleteRateio) {
        let index = this.lstRateioDespesas.findIndex(d => d.identificacaoColetor.replace(' ', '') === row.identificacaoColetor.replace(' ', ''));
        this.lstRateioDespesas.splice(index, 1);

        if (this.lstRateioDespesas.length > 0) {
          this.tipoDocumentoForm.controls['frmTipoDoc'].disable();
        } else {
          this.tipoDocumentoForm.controls['frmTipoDoc'].enable();
        }

        this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
        this.somaRateio = this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
      }
    });
  }

  deleteAllRows() {
    if (this.modoEdicao && !this.currentUser.movimentarProtocoloTerceiros &&
      this.protocoloEdicao.loginResponsavel !== this.currentUser.login ||
      (this.modoEdicao && this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4)) {
      return;
    }

    this.messageModel = new Message(
      'Rateios',
      'Confirma a exclusão de todos os itens de rateio?',
      '',
      'confirm'
    );

    let confirmDeleteRateio = false;
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });

    dialogRef.afterClosed().subscribe(result => {
      confirmDeleteRateio = result;
      if (confirmDeleteRateio != null && confirmDeleteRateio) {
        this.lstRateioDespesas = new Array<RateioDespesas>();
        this.tipoDocumentoForm.controls['frmTipoDoc'].enable();
        this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
      }
    });
  }

  deleteFile(doc) {
    if (this.modoEdicao && this.Adiantamento) {
      return;
    }

    if (this.modoEdicao && !this.currentUser.movimentarProtocoloTerceiros &&
      this.protocoloEdicao.loginResponsavel !== this.currentUser.login ||
      (this.modoEdicao && this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4
        && this.protocoloEdicao.idStatusNovo !== 7)) {
      return;
    }

    let index = this.LstUploadFiles.findIndex(d => d === doc);
    this.LstUploadFiles.splice(index, 1);
    this.FormDataUpload.delete(doc);

    if (this.cabecalhoProtocolo.imagens !== undefined) {
      this.cabecalhoProtocolo.imagens.splice(index, 1);
    }
  }

  // ============== VERIFICAÇÕES =============
  VerificaDiagramaDeRede() {
    localStorage.setItem('tipoColetor', JSON.stringify(this.rateioDespesasForm.controls['frmTipoColetor'].value));

    if (this.rateioDespesasForm.controls['frmTipoColetor'].value !== 'undefined') {
      this.PesColetorCustos = true;
    } else {
      this.PesColetorCustos = false;
    }

    if (this.rateioDespesas.codTipoColetor !== 'N') {
      this.rateioDespesasForm.controls['frmNumOperacao'].disable();
      this.rateioDespesas.operacaoSubNumero = '';
      this.diagramaDeRede = false;
    } else {
      this.rateioDespesasForm.controls['frmNumOperacao'].enable();
      this.diagramaDeRede = true;
    }

    this.limparColetorCustos();
  }

  limparColetorCustos() {
    const frmColetorCustos = this.rateioDespesasForm?.get('frmColetorCustos');

    if (frmColetorCustos) {
      frmColetorCustos.setValue('');
      frmColetorCustos.setErrors(null);
    }

  }

  VerificaParcelado() {
    this.parcelado = !this.parcelado;

    if (this.parcelado) {
      this.cabecalhoForm.controls['frmCondicaoPag'].enable();
    } else {
      this.cabecalhoForm.controls['frmCondicaoPag'].disable();
      this.cabecalhoProtocolo.codigoParametro = '';
    }
  }

  VerificaRetornoAdiantamentos(adiantamentos: Array<SaldoAdiantamento>) {
    if (adiantamentos != null && adiantamentos.length > 0) {
      if (adiantamentos.filter(e => e.status === 'E').length > 0) {
        this.messageModel = new Message(
          'Adiantamentos',
          adiantamentos[0].mensagem,
          '',
          'error'
        );

        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      } else {
        const dialogRef = this.dialog.open(PopupAdiantamentosComponent, { data: adiantamentos });
        dialogRef.afterClosed().subscribe(result => {
          if (result != null && result.length > 0) {
            this.lstAdiantamentos = result;
          }
        });
      }
    }
  }

  VerificaCamposObrigRateio() {
    return this.empresaMRV != null && this.empresaMRV.codigoEmp != null && this.rateioDespesas.codTipoColetor != null && this.rateioDespesas.identificacaoColetor != "";
  }

  VerificarAdiantamentoNaoFiscal() {
    let confirmacaoTermo: boolean;

    if (this.tipoDocSelected != null && this.tipoDocSelected.codTipoDocumento === '13') {
      const dialogRef = this.dialog.open(PopupTermoAdiantamentoComponent);
      dialogRef.afterClosed().subscribe(result => {
        confirmacaoTermo = result;

        if (!confirmacaoTermo) { this.ngOnInit(); }
      });
    }

    this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
  }

  VerificarDocumentoNaoFiscal() {
    let confirmacaoTermo: boolean;

    if (this.tipoDocSelected != null && this.tipoDocSelected.codTipoDocumento === '13') {
      this.fv60 = false;
      this.Fundofixo = false;
      this.Adiantamento = true;

      const dialogRef = this.dialog.open(PopupTermoAdiantamentoComponent);
      dialogRef.afterClosed().subscribe(result => {
        confirmacaoTermo = result;

        if (!confirmacaoTermo) { this.ngOnInit(); }
      });
    } else {
      this.Fundofixo = false;
      this.Adiantamento = false;
      this.fv60 = true;
    }

    this.getTiposDespesas(this.tipoDocSelected.codTipoDocumento);
  }

  VerificaRetornoDocumento(documento: DocumentoPreEditadoRtn) {
    if (documento.success) {
      const docPreEditado = this.CarregarDadosPreEditado();
      docPreEditado.idProtocolo = documento.data.idProtocolo;
      if (!this.modoEdicao) {
        docPreEditado.documento = documento.data.documento;
        this.documentoSAP = documento.data.documento;
      }
      this.uploadFiles(docPreEditado);
    } else {
      this.messageModel = new Message(
        'Ocorreu um problema ao criar o documento pré-editado no SAP',
        documento.message,
        '',
        'error'
      );
      this.loadComponent.startLoading(false);
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      console.log(documento);
    }
  }

  verificaFornecedor(fornecedor: Fornecedor) {
    if (fornecedor == null || fornecedor.status === 'E') {
      this.messageModel = new Message(
        'Fornecedor',
        fornecedor.mensagem,
        '',
        'error'
      );

      this.fornecedor = new Fornecedor();
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    } else {
      if (this.tipoDocSelected.codTipoDocumento === '04' && fornecedor.codigoGrupoContaFornecedor !== 'YFCS') {
        this.messageModel = new Message(
          'Fornecedor',
          'Grupo de fornecedor impedido de criar o tipo de documento Concessionárias.',
          '""',
          'error'
        );

        this.fornecedor = new Fornecedor();
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      } else {
        this.cabecalhoForm.controls['frmNomeFornecedor'].setValue(this.fornecedor.nomeFornecedor);
      }
    }
  }

  VerificaColetoresInvalidos(coletores: ColetorCustos[]) {
    this.coletoresCustoError = new Array<ColetorCustos>();

    coletores.forEach(cc => {
      if (cc.status === 'E') {
        this.coletoresCustoError.push(cc);
      }
    });

    if (this.coletoresCustoError.length > 0) {
      this.dialog.open(PopUpColetoresComponent, { data: this.coletoresCustoError });
    } else {
      this.IncluirRateioDataSource();
    }
  }
  // ============== FIM - VERIFICAÇÕES =============

  // ============== VALIDAÇÕES DE CAMPOS =============

  limparVencimento() {
    this.cabecalhoProtocolo.primeiroVencimento = null;
  }

  validarCodigoBarras() {
    var re = /[^0-9\.]+|\.|\ |\-|\//g;
    this.cabecalhoProtocolo.codigoBarras = this.cabecalhoProtocolo.codigoBarras.replace(re, '');

    let codigoBarras: string = this.cabecalhoProtocolo.codigoBarras;
    let valor: number = 0;
    let dataVencimento: Date;
    let ano: string;
    let mes: string;
    let dia: string;
    this.codigoBarrasValido = true;
    this.maxDate = null;

    if (codigoBarras) {
      codigoBarras = this.mask.unmaskNumber(codigoBarras)

      if (codigoBarras.startsWith('8')) {

        let bloco1: string = codigoBarras.substr(0, 11);
        let bloco2: string = codigoBarras.substr(12, 11);
        let bloco3: string = codigoBarras.substr(24, 11);
        let bloco4: string = codigoBarras.substr(36, 11);
        let codigoSemDig: string = bloco1 + bloco2 + bloco3 + bloco4;

        if (codigoBarras.length !== 48) {
          return false;
        }

        let val: string = codigoSemDig.substr(4, 11);
        valor = (Number(val) / 100);

        if (valor > 0) {
          this.cabecalhoProtocolo.valor = valor;
        }

        ano = codigoSemDig.substr(19, 4);
        mes = codigoSemDig.substr(23, 2);
        dia = codigoSemDig.substr(25, 2);

        dataVencimento = new Date(ano + '-' + mes + '-' + dia);

        if (moment.isDate(dataVencimento) &&
          dataVencimento.toString() !== 'Invalid Date' &&
          this.cabecalhoProtocolo.primeiroVencimento !== dataVencimento) {
          this.cabecalhoProtocolo.primeiroVencimento = dataVencimento;
          this.maxDate = dataVencimento;
        }
        if (dataVencimento < new Date()) {
          this.maxDate = null;
        }
      } else {
        const dataBaseBoleto: Date = new Date('1997-10-07 0:00:00');
        let numDias = codigoBarras.substr(33, 4);
        let dataVencimento = moment(dataBaseBoleto).add(Number(numDias), 'd');
        let valor = Number(codigoBarras.substr(37)) / 100;

        this.cabecalhoProtocolo.primeiroVencimento = dataVencimento.toDate();

        if (valor > 0) {
          this.cabecalhoProtocolo.valor = valor;
        }

        this.maxDate = dataVencimento.toDate();

        if (dataVencimento.toDate() < new Date()) {
          this.maxDate = null;
        }
      }
    }
    return true;
  }

  // ============== FIM - VERIFICAÇÕES =============

  UpdateDateEmissao() {
    this.cabecalhoForm.controls['frmDtEmissao'].setValue(this.cabecalhoProtocolo.emissao);
  }

  downloadImage(image) {
    let img: ImagemNotaFiscal;
    if (this.cabecalhoProtocolo.imagens !== undefined) {
      img = this.cabecalhoProtocolo.imagens.filter(i => i.nomeDocumento === image)[0];

      var extencaoArquivo = img.nomeDocumento.split('.');
      var arrayBytes = this.base64ToArrayBuffer(img.dadosImagem);
      var blob = new Blob([arrayBytes], { type: `image/${extencaoArquivo[1]}` });

      let link = document.createElement('a');

      link.href = URL.createObjectURL(blob);

      link.setAttribute('visibility', 'hidden');
      link.download = img.nomeDocumento;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  myParse(value: any): Date | null {
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');
      return new Date(Number(str[2]), Number(str[1]) - 1, Number(str[0]), 12);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }

  navigateTipoDoc() {
    $('#TipoDoc').addClass('visible-none');
    $('#divDuvida').addClass('visible-none');

    $('#SelectDoc').removeClass('visible-none');
    $('#btnTipoDoc').removeAttr('disabled');
    return false;
  }

  getErrorMessage() {
    return this.fTpDoc.frmTipoDoc.hasError('required') ? 'Escolha um Tipo de Documento' : '';
  }

  getErrorMessageNumOperacao() {
    if (this.fRateio.frmNumOperacao.hasError('maxlength')) {
      return 'O número da operação deve possuir no máximo 4 caracteres.'
    } else {
      return 'Numero da operação é obrigatório quando o tipo de coletor é igual a Diagrama de Rede';
    }
  }

  getErrorCNPJMessage() {
    if (this.f.frmCnpjEmpresa.hasError('minlength') ||
      this.f.frmCnpjFornecedor.hasError('minlength')) { return 'CNPJ inválido'; }

    if (this.f.frmCnpjEmpresa.hasError('required') ||
      this.f.frmCnpjFornecedor.hasError('required')) { return 'CPNJ deve ser preenchido'; }
  }

  PesquisarColetorCustos() {
    let confirmacaoTermo: string;

    const dialogRef = this.dialog.open(PopupColetorCustosComponent);
    dialogRef.afterClosed().subscribe(result => {
      confirmacaoTermo = result;
      if (confirmacaoTermo !== '') {
        this.rateioDespesas.identificacaoColetor = confirmacaoTermo;
      }
    });
  }

  filterDataEmissao = (d: Date): boolean => {
    return d <= new Date();
  }

  filterDataVencimento = (d: Date): boolean => {
    const dataAtual: Date = new Date();
    dataAtual.setHours(-24);
    return d >= dataAtual;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  exibirNomeAprovador(login: any) {
    if (login) {
      return login.nome;
    }
  }

  visualizarStatus() {
    this.dialog.open(StatusProtocoloFiscalModalComponent, {
      data: this.idProtocolo, minWidth: '75%',
      maxWidth: '75%', maxHeight: '600px'
    });
  }
}
